import React from 'react';
import PropTypes from 'prop-types';

const Delete = ({ fill, width }) => (
  <svg width={width} viewBox="0 0 13 16" className="delete-icon">
    <g stroke="none" strokeWidth="1" fillRule="evenodd">
      <g transform="translate(-1574.000000, -562.000000)">
        <path
          fill={fill}
          d="M1585.82031,563.320312 L1585.82031,565 L1574.17969,565 L1574.17969,563.320312 L1577.07031,563.320312 L1577.92969,562.5 L1582.07031,562.5 L1582.92969,563.320312 L1585.82031,563.320312 Z M1575,575.820312 L1575,565.820312 L1585,565.820312 L1585,575.820312 C1585,576.263023 1584.83073,576.653644 1584.49219,576.992188 C1584.15364,577.330731 1583.76302,577.5 1583.32031,577.5 L1576.67969,577.5 C1576.23698,577.5 1575.84636,577.330731 1575.50781,576.992188 C1575.16927,576.653644 1575,576.263023 1575,575.820312 Z"
        />
      </g>
    </g>
  </svg>
);

Delete.defaultProps = {
  fill: '#979C99',
  width: '2rem',
};

Delete.propTypes = {
  fill: PropTypes.string,
  width: PropTypes.string,
};

export default Delete;
